export const SmartSpaceOverview = () => {
	return null;
};
